import React from 'react';
import PropTypes from 'prop-types';
import _ from "underscore";

// NOSONAR: `category` and `label` are Blockly toolbox-XML pseudo-elements,
// not real DOM elements. Attributes like `iconclass` and `text` are valid
// Blockly toolbox attributes.
const Sound = (props) => {
    const { blocks, playServerSound } = props;
    if (!playServerSound) return null;

    const childBlocks = _.map(blocks, ({ component: BlockComponent }, blockKey) => (
        <BlockComponent {...props} playServerSound={playServerSound} key={blockKey}/>
    ));

    if (childBlocks.length > 0) {
        return (
            <category name='Sound' id='sound' iconclass='category with-icon-paths snap-icon-sound_dual'>{/* NOSONAR */}
                <label text="Sound"></label>{/* NOSONAR */}
                { childBlocks }
            </category>
        );
    }

    return null;
};

Sound.propTypes = {
    blocks: PropTypes.object,
    playServerSound: PropTypes.func,
};

export default Sound;